module.exports = __webpack_public_path__ + "static/media/20210212_223807_591_IMG_2263.7365d39a.jpg";